import React, { useState, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import AssinaturaRodape from '@componentes/AssinaturaRodape';
import logoMV from '../../assets/logos/logo-mv.svg';

import './styles.css';

function TableReport ({
  title,
  headerList,
  children,
  assinatura,
  assinatura2,
  assinaturaVisible = true
}) {
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const [headerListItens, setHeaderListItens] = useState([]);
  const [logo, setLogo] = useState(logoMV);

  useLayoutEffect(() => {
    if (headerList) {
      setHeaderListItens(headerList);
    }
  }, [headerList]);

  useLayoutEffect(() => {
    setLogo(logoMV);
    if (dadosGeraisHospital && dadosGeraisHospital.logoBase64) {
      setLogo(`data:image/png;base64,${dadosGeraisHospital.logoBase64}`);
    }
  }, [dadosGeraisHospital]);

  return (
    dadosGeraisHospital && (
      <div>
        <div className='mv-pdf-report-container'>
          <div className='page'>
            <table style={{ fontSize: '12px' }}>
              <thead>
                <tr>
                  <th colSpan={`${headerListItens.length}`}>
                    <header>
                      <img alt={dadosGeraisHospital.razaosoc} src={logo} />
                      <h2>{title}</h2>
                    </header>
                  </th>
                </tr>

                {!!headerListItens.length && (
                  <tr>
                    {headerListItens.map((titleHeader, i) => (
                      <th key={i}>{titleHeader}</th>
                    ))}
                  </tr>
                )}
              </thead>
              <tbody>{children}</tbody>
            </table>
          </div>
        </div>
        <AssinaturaRodape
          texto={`Total: ${children.length} itens`}
          assinatura={assinaturaVisible? assinatura : null}
          assinatura2={assinatura2? assinatura2 : null}
          localAndData={dadosGeraisHospital.localAndData}
        />
      </div>
    )
  );
}

export default TableReport;



// WEBPACK FOOTER //
// ./src/componentes/TableReport/index.js